module.exports = __webpack_public_path__ + "img/icon01.47415a6f.jpg";